import React from "react";

import FeedsFeature from "../features/board/components/Feeds";

function Feeds(props) {
  return <FeedsFeature {...props} />;
}

export default Feeds;
